"use client";

import ApplicationStats from "./ApplicationStats";
import AppliedJobs from "./AppliedJobs";
import AccountInfo from "./AccountInfo";
import useCandidateDashboard from "../../hooks/useCandidateDashboard";


const fallbackData = {
  candidate: {
    id: "0",
    name: "Candidate Name",
    email: "candidate@email.com",
    role: "CANDIDATE",
    authProvider: "LOCAL",
    createdAt: "",
    lastLoginAt: "",
  },
  applications: [],
  resume: null,
  video: null,
};

export default function CandidateDashboard() {
  const {
    dashboard,
    error,
    refresh,
  } = useCandidateDashboard();


  const data = dashboard || fallbackData;



  return (
    <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-[1400px]">

        {error && (
          <div className="mb-4 flex items-center justify-between rounded-2xl border border-red-200 bg-red-50 p-4">
            <p className="text-sm font-medium text-red-700">
              {error}
            </p>

            <button
              type="button"
              onClick={refresh}
              className="
                rounded-lg
                bg-red-600
                px-4
                py-2
                text-xs
                font-semibold
                text-white
                transition-colors
                hover:bg-red-700
              "
            >
              Retry
            </button>
          </div>
        )}

        <div className="mb-4">
          <ApplicationStats
            applications={data.applications}
          />
        </div>

        <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-12">

          <div className="min-w-0 lg:col-span-8">
            <AppliedJobs
              applications={data.applications}
            />
          </div>

          <div className="min-w-0 space-y-3 lg:col-span-4">

            <AccountInfo
              candidate={data.candidate}
            />


            

          </div>

        </div>

      </div>
    </div>
  );
}